import React, { useRef, useState, useEffect } from "react";
import DyeingImg from "../../../assets/images/platform/dyeing-min.png";
import PrintingImg from "../../../assets/images/platform/printing.png";
import TestingImg from "../../../assets/images/infrastructure/testing.jpg";
import WeavingImg from "../../../assets/images/platform/weaving.png";

import wDyeingImg from "../../../assets/images/platform/webp/dyeing-min.webp";
import wPrintingImg from "../../../assets/images/platform/webp/printing.webp";
import wTestingImg from "../../../assets/images/infrastructure/webp/testing.webp";
import wWeavingImg from "../../../assets/images/platform/webp/weaving.webp";

import "./LeadsServices.scss";

const SERVICES = [
  {
    image: WeavingImg,
    webpImage: wWeavingImg,
    title: "Weaving",
    description:
      "Finest weaving techniques for the perfect outcome such as plain, basket, twill, satin, jacquard, leno, pile, etc.",
  },
  {
    image: PrintingImg,
    webpImage: wPrintingImg,
    title: "Printing",
    description:
      "High-quality direct, discharge, resist or transfer printing with techniques like block, blotch, burn-out, roller, and screen printing to make your designs come out alive.",
  },
  {
    image: DyeingImg,
    webpImage: wDyeingImg,
    title: "Dyeing",
    description:
      "Latest dyeing techniques and methods used to dye fibre, yarn or fabric, such as solution, stock, beam, etc. - the most-advanced in the industry.",
  },
  {
    image: TestingImg,
    webpImage: wTestingImg,
    title: "Testing",
    description:
      "Our elaborate testing capabilities are computerized and deliver accurate monitoring, defect classification, and prevention, and ensure 100% quality assurance to our customers.",
  },
];

const LeadsServices = () => {
  const [current, setCurrent] = useState(0);
  const scrollerRef = useRef(null);

  useEffect(() => {
    const interval = setInterval(() => {
      const nextIndex = (current + 1) % SERVICES.length;
      scrollToCard(nextIndex);
    }, 5000);

    return () => clearInterval(interval);
  }, [current]);

  const scrollToCard = (index) => {
    if (scrollerRef.current) {
      const card = scrollerRef.current.firstChild;
      if (!card) return;
      const style = window.getComputedStyle(card);
      const gap = parseInt(style.marginRight || 16, 10);
      const cardWidth = card.offsetWidth + gap;

      scrollerRef.current.scrollTo({
        left: index * cardWidth,
        behavior: "smooth",
      });
      setCurrent(index);
    }
  };

  return (
    <section className="leads_services_section">
      <h3 className="leads_section_heading">Wide Range of Services</h3>

      <div className="leads_services_scroller" ref={scrollerRef}>
        {SERVICES.map(({ image, title, description }, index) => (
          <div key={index} className="leads_services_item">
            <img src={image} alt={title} />
            <div className="leads_box">
              <div className="section_item_heading">{title}</div>
              <div className="section_item_description">{description}</div>
            </div>
          </div>
        ))}
      </div>

      <div className="hero_radioContainer leads_radio_controller">
        {SERVICES.map((_, index) => (
          <div
            key={index}
            className={`radioWrapper ${
              index === current ? "activeRadioWrapper" : ""
            }`}
            onClick={() => scrollToCard(index)}
          >
            <input
              className={`herodot ${index === current ? "active" : ""}`}
              type="radio"
              name="hero_sliders"
              id={`slider-${index}`}
              checked={index === current}
              readOnly
            />
          </div>
        ))}
      </div>
    </section>
  );
};

export default LeadsServices;
